export const environment = {
  production: true,
  endpoint: 'https://core-bancarioresidencial-neighbors-qr.vercel.app/api',
  secure: 'awmxGyRg7KEGViAjXm3JBC9po49lc0r3452',
  firebaseConfig: {
    apiKey: "AIzaSyA52-NiHzDwCyBypK_e_0fmejijCMXUKaM",
    authDomain: "neighbors-qr-bancario-resident.firebaseapp.com",
    projectId: "neighbors-qr-bancario-resident",
    storageBucket: "neighbors-qr-bancario-resident.firebasestorage.app",
    messagingSenderId: "819642114945",
    appId: "1:819642114945:web:078c78d0371ba9520a3e80",
    measurementId: "G-M97LR90YSD"
  }
};
